import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import Index from "@views/home/Index";
import member from "@views/member/member";
import Search from "@views/shop/GoodSearch";
import Category from "@views/shop/GoodsClass";
import ShoppingCart from "@views/shop/ShoppingCart";
import GoodsList from "@views/shop/GoodsList";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import toLogin from "@libs/login";
import Loading from "@views/Loading";
Vue.use(Router);

const router = new Router({
  //mode: "history",
  routes: [
    {
      path: "/mychat",
      name: "mychat",
      meta: {
        title: "客服聊天",
        keepAlive: true,
        backgroundColor: "#fff",
        footer: true,
        auth: false,
      },
      component: () => import("@/pages/chat/index.vue"),
    },
    {
      path: "/article",
      name: "article",
      meta: {
        title: "公告列表",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: () => import("../views/article"),
    },
    {
      path: "/article_detail",
      name: "article_detail",
      meta: {
        title: "公告详情",
        keepAlive: true,
        footer: true,
        backgroundColor: "#ffffff",
      },
      component: () => import("../views/article/detail"),
    },
    {
      path: "/company-profile/:section",
      name: "company_profile",
      meta: {
        title: "企业资料",
        keepAlive: false,
        backgroundColor: "#f5f7fa",
      },
      component: () => import("@views/home/CompanyProfile.vue"),
    },
    {
      path: "/newcomer-gift",
      name: "NewcomerGift",
      meta: {
        title: "新客专项礼",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f4f7fb",
      },
      component: () => import("@views/wealth/NewcomerGift.vue"),
    },
    {
      path: "/investment-plan",
      name: "InvestmentPlan",
      meta: {
        title: "定投专区",
        keepAlive: true,
        footer: true,
        backgroundColor: "#f3f6fa",
      },
      component: () => import("@views/wealth/InvestmentPlan.vue"),
    },
    {
      path: "/knowledge",
      name: "KnowledgeHub",
      meta: {
        title: "资讯与投教",
        keepAlive: true,
        footer: true,
        backgroundColor: "#f4f7fb",
      },
      component: () => import("@views/wealth/KnowledgeHub.vue"),
    },
    {
      path: "/company-hub",
      name: "CompanyHub",
      meta: {
        title: "关于我们",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f4f7fa",
      },
      component: () => import("@views/wealth/CompanyHub.vue"),
    },
    {
      path: "/",
      name: "Index",
      meta: {
        title: "首页",
        keepAlive: true,
        footer: true,
        backgroundColor: "#ffffff",
      },
      component: Index,
    },
    {
      path: "/customer/chat/:id/:productId?",
      name: "CustomerService",
      meta: {
        title: "客服聊天",
        keepAlive: false,
        auth: true,
      },
      component: () => import("@views/user/CustomerService.vue"),
    },
    {
      path: "/incomeDetail",
      name: "incomeDetail",
      meta: {
        title: "收益明细",
        keepAlive: true,
        // auth: true
      },
      component: () => import("@views/user/incomeDetail.vue"),
    },
    {
      path: "/member",
      name: "member",
      meta: {
        title: "会员",
        keepAlive: true,
        footer: true,
        backgroundColor: "#f5f5f5",
      },
      component: member,
    },
    {
      path: "/member_integal",
      name: "member_integal",
      meta: {
        title: "购物券",
        keepAlive: true,
        footer: false,
      },
      component: () => import("@views/member/member_integal.vue"),
    },
    {
      path: "/member_fans",
      name: "member_fans",
      meta: {
        title: "查看粉丝",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/member/member_fans.vue"),
    },
    {
      path: "/invitation",
      name: "Invitation",
      meta: {
        title: "邀请好友",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: () => import("@views/member/Invitation.vue"),
    },
    {
      path: "/team",
      name: "team",
      meta: {
        title: "我的团队",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: () => import("@views/home/team.vue"),
    },
    {
      path: "/customerService",
      name: "customerService",
      meta: {
        title: "在线客服",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/kefu/CustomerService.vue"),
    },
    {
      path: "/member_transform",
      name: "member_transform",
      meta: {
        title: "积分转余额",
        keepAlive: true,
        footer: false,
      },
      component: () => import("@views/member/member_transform.vue"),
    },
    {
      path: "/myInvest",
      name: "myInvest",
      meta: {
        title: "我的投资",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/home/MyInvest.vue"),
    },
    {
      path: "/xnblist",
      name: "xnblist",
      meta: {
        title: "USD购买",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/shop/xnblist.vue"),
    },
    {
      path: "/moneyDetail",
      name: "moneyDetail",
      meta: {
        title: "资金明细",
        keepAlive: true,
        backgroundColor: "#fff",
        footer: true,
      },
      component: () => import("@views/home/MoneyDetail.vue"),
    },
    {
      path: "/dhlist",
      name: "dhlist",
      meta: {
        title: "兑换记录",
        keepAlive: true,
        backgroundColor: "#fff",
        footer: true,
      },
      component: () => import("@views/home/dhlist.vue"),
    },
    {
      path: "/Contract",
      name: "Contract",
      meta: {
        title: "我的合同",
        keepAlive: true,
        footer: false,
      },
      component: () => import("@views/home/Contract.vue"),
    },
    {
      path: "/xuzhi",
      name: "xuzhi",
      meta: {
        title: "用户须知",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/user/xuzhi.vue"),
    },
    {
      path: "/qiehuan",
      name: "qiehuan",
      meta: {
        title: "切换服务器",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/home/qiehuan.vue"),
    },
    {
      path: "/user",
      name: "User",
      meta: {
        title: "个人中心",
        keepAlive: false,
        footer: true,
        backgroundColor: "#F5F5F8",
      },
      component: () => import("@views/user/User.vue"),
    },
    {
      path: "/my-assets",
      name: "my-assets",
      meta: {
        title: "交易",
        keepAlive: true,
        backgroundColor: "#fff",
        footer: true,
      },
      component: () => import("@views/member/my-assets.vue"),
    },
    {
      path: "/rilibaoindex",
      name: "rilibaoindex",
      meta: {
        title: "日利宝",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/home/rilibao/rilibaoindex.vue"),
    },
    {
      path: "/rilibaoindex",
      name: "rilibaoindex",
      meta: {
        title: "日利宝",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/home/rilibao/rilibaoindex.vue"),
    },
    {
      path: "/zhuanhuan",
      name: "zhuanhuan",
      redirect: "/",
      meta: {
        title: "首页",
        keepAlive: true,
        footer: true,
      },
    },
    {
      path: "/rlbadd",
      name: "rlbadd",
      meta: {
        title: "日利宝转入",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/home/rilibao/rlbadd.vue"),
    },
    {
      path: "/rlbout",
      name: "rlbout",
      meta: {
        title: "日利宝转出",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/home/rilibao/rlbout.vue"),
    },
    {
      path: "/jiangli",
      name: "JianglI",
      meta: {
        title: "奖励制度",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: () => import("@views/article/BackendArticlePage.vue"),
      props: { pageCode: "reward_rules", fallbackTitle: "奖励制度" },
    },
    {
      path: "/anquan",
      name: "anquan",
      meta: {
        title: "安全保障",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: () => import("@views/article/BackendArticlePage.vue"),
      props: { pageCode: "security_guarantee", fallbackTitle: "安全保障" },
    },
    {
      path: "/news",
      name: "news",
      meta: {
        title: "新手帮助",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: () => import("@views/article/BackendArticlePage.vue"),
      props: { pageCode: "common_questions", fallbackTitle: "新手帮助" },
    },
    {
      path: "/problem",
      name: "ProBlem",
      meta: {
        title: "常见问题",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: () => import("@views/article/BackendArticlePage.vue"),
      props: { pageCode: "common_questions", fallbackTitle: "常见问题" },
    },
    {
      path: "/member_transBg",
      name: "member_transBg",
      meta: {
        title: "积分转出到HG",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/member/member_transBg.vue"),
    },
    {
      path: "/memmber_transDeta",
      name: "memmber_transDeta",
      meta: {
        title: "提现记录",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/member/memmber_transDeta.vue"),
    },
    {
      path: "/bank",
      name: "bank",
      meta: {
        title: "银行卡",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: () => import("../views/pay/bank"),
    },
    {
      path: "/bank_add",
      name: "bank_add",
      meta: {
        title: "添加银行卡",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: () => import("../views/pay/bank/add"),
    },
    {
      path: "/addUSD",
      name: "addUSD",
      meta: {
        title: "添加USD",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: () => import("../views/pay/bank/addusdt"),
    },
    {
      path: "/withdrawal_record",
      name: "withdrawal_record",
      meta: {
        title: "提现记录",
        keepAlive: true,
        footer: true,
        backgroundColor: "#f5f5f5",
      },
      component: () => import("../views/pay/withdrawalRecord"),
    },
    {
      path: "/deposit_record",
      name: "deposit_record",
      meta: {
        title: "充值记录",
        keepAlive: true,
        footer: true,
        backgroundColor: "#f5f5f5",
      },
      component: () => import("../views/pay/depositRecord"),
    },
    {
      path: "/txCash",
      name: "txCash",
      meta: {
        title: "提现",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/user/tixian.vue"),
    },
    {
      path: "/language",
      name: "language",
      meta: {
        title: "语言选择",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/user/Language.vue"),
    },
    {
      path: "/memmber_business",
      name: "memmber_business",
      meta: {
        title: "实名认证",
        keepAlive: true,
        backgroundColor: "#F5F5F8",
        footer: true,
      },
      component: () => import("@views/member/memmber_business.vue"),
    },
    {
      path: "/member_level",
      name: "member_level",
      meta: {
        title: "会员专区",
        keepAlive: true,
        footer: false,
      },
      component: () => import("@views/member/member_level.vue"),
    },
    {
      path: "/member_fansOrder",
      name: "member_fansOrder",
      meta: {
        title: "订单管理",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/member/member_fansOrder.vue"),
    },
    {
      path: "/category/:pid?",
      name: "GoodsClass",
      meta: {
        title: "产品",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: Category,
    },
    {
      path: "/pay/:id?",
      name: "GoodsPay",
      meta: {
        title: "产品认购",
        keepAlive: false,
        footer: true,
        backgroundColor: "#F2F1F6",
      },
      component: () => import("@views/shop/GoodsPay.vue"),
    },
    {
      path: "/finish",
      name: "GoodsFinish",
      meta: {
        title: "完成",
        keepAlive: false,
        footer: true,
        backgroundColor: "#F2F1F6",
      },
      component: () => import("@views/shop/GoodsFinish.vue"),
    },
    {
      path: "/shezhi",
      name: "shezhi",
      meta: {
        title: "设置",
        keepAlive: false,
        footer: true,
        backgroundColor: "#F2F1F6",
      },
      component: () => import("@views/user/shezhi.vue"),
    },
    {
      path: "/audits",
      name: "CashAudit",
      meta: {
        title: "提现审核",
        keepAlive: true,
        footer: true,
      },
      component: () => import("@views/user/promotion/CashAudit.vue"),
    },
    {
      path: "/Signln",
      name: "Signln",
      meta: {
        title: "签到记录",
        keepAlive: false,
        footer: true,
        backgroundColor: "#F5F5F8",
      },
      component: () => import("@views/home/SignIn.vue"),
    },
    {
      path: "/JfList",
      name: "JfList",
      meta: {
        title: "积分商城",
        keepAlive: false,
        footer: true,
        backgroundColor: "#F5F5F8",
      },
      component: () => import("@views/shop/JfList.vue"),
    },
    {
      path: "/JfContent/:id?",
      name: "JfList",
      meta: {
        title: "积分详情",
        keepAlive: false,
        footer: false,
        backgroundColor: "#F5F5F8",
      },
      component: () => import("@views/shop/JfContent.vue"),
    },
    {
      path: "/JfPay/:id?",
      name: "JfPay",
      meta: {
        title: "提交订单",
        keepAlive: false,
        footer: false,
        backgroundColor: "#F5F5F8",
      },
      component: () => import("@views/shop/JfPay.vue"),
    },
    {
      path: "/JfOver/:id?",
      name: "JfOver",
      meta: {
        title: "付款成功",
        keepAlive: false,
        footer: false,
        backgroundColor: "#F5F5F8",
      },
      component: () => import("@views/shop/JfOver.vue"),
    },
    {
      path: "/huzhuan",
      name: "huzhuan",
      redirect: "/",
      meta: {
        title: "首页",
        keepAlive: false,
        footer: false,
        backgroundColor: "#F5F5F8",
      },
    },

    {
      path: "/collection",
      name: "GoodsCollection",
      meta: {
        title: "收藏商品",
        keepAlive: false,
        auth: true,
      },
      component: () => import("@views/shop/GoodsCollection.vue"),
    },
    {
      path: "/search",
      name: "GoodSearch",
      meta: {
        title: "搜索商品",
        keepAlive: true,
        backgroundColor: "#fff",
      },
      component: Search,
    },

    {
      path: "/NewsDetail/:id?",
      name: "NewsDetail",
      meta: {
        title: "新闻详情",
        keepAlive: false,
        backgroundColor: "#fff",
      },
      component: () => import("@views/shop/news/NewsDetail.vue"),
    },
    {
      path: "/news_list",
      name: "NewsList",
      meta: {
        title: "新闻",
        keepAlive: true,
        backgroundColor: "#fff",
      },
      component: () => import("@views/shop/news/NewsList.vue"),
    },
    {
      path: "/evaluate_list/:id",
      name: "EvaluateList",
      meta: {
        title: "商品评分",
        keepAlive: true,
        auth: true,
      },
      component: () => import("@views/shop/EvaluateList.vue"),
    },
    {
      path: "/goods_evaluate/:id",
      name: "GoodsEvaluate",
      meta: {
        title: "商品评价",
        keepAlive: true,
        auth: false,
      },
      component: () => import("@views/shop/GoodsEvaluate.vue"),
    },
    {
      path: "/promotion",
      name: "GoodsPromotion",
      meta: {
        title: "促销单品",
        keepAlive: false,
      },
      component: () => import("@views/shop/GoodsPromotion.vue"),
    },
    {
      path: "/hot_new_goods/:type",
      name: "HotNewGoods",
      meta: {
        title: "热门榜单",
        keepAlive: false,
      },
      component: () => import("@views/shop/HotNewGoods.vue"),
    },
    {
      path: "/detail/:id",
      name: "GoodsCon",
      meta: {
        title: "商品详情",
        keepAlive: false,
        footer: true,
      },
      component: () => import("@views/shop/GoodsCon.vue"),
    },
    {
      path: "/shop/storeList/:gonames?",
      name: "StoreList",
      meta: {
        title: "门店列表",
        keepAlive: false,
      },
      component: () => import("@views/shop/StoreList.vue"),
    },
    {
      path: "/shop/touZiList",
      name: "touZiList",
      meta: {
        title: "投资列表",
        keepAlive: false,
        backgroundColor: "#fff",
      },
      component: () => import("@views/shop/touZiList.vue"),
    },
    {
      path: "/cart",
      name: "ShoppingCart",
      meta: {
        title: "发现",
        keepAlive: true,
        footer: true,
      },
      component: ShoppingCart,
    },
    {
      path: "/goods_list",
      name: "GoodsList",
      meta: {
        title: "商品列表",
        keepAlive: true,
      },
      component: GoodsList,
    },
    {
      path: "/register",
      alias: "/Register",
      name: "Register",
      meta: {
        title: "注册",
        keepAlive: true,
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Register.vue"),
    },
    {
      path: "/MyIntegral",
      name: "MyIntegral",
      meta: {
        title: "我的投资",
        keepAlive: true,
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/home/MyIntegral.vue"),
    },
    {
      path: "/CzContent",
      name: "CzContent",
      meta: {
        title: "充值",
        keepAlive: false,
        footer: true,
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/home/CzContent.vue"),
    },
    {
      path: "/change_password",
      name: "ChangePassword",
      meta: {
        title: "修改密码",
        keepAlive: true,
        backgroundColor: "#fff",
        auth: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "login" */ "@views/user/ChangePassword.vue"
        ),
    },
    {
      path: "/retrieve_password",
      name: "RetrievePassword",
      meta: {
        title: "找回密码",
        keepAlive: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "login" */ "@views/user/RetrievePassword.vue"
        ),
    },
    //

    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录",
        keepAlive: false,
        footer: true,
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Login.vue"),
    },
    {
      path: "/LoginPass",
      name: "LoginPass",
      meta: {
        title: "修改登录密码",
        keepAlive: false,
        footer: true,
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/LoginPass.vue"),
    },
    {
      path: "/Grade",
      name: "Grade",
      meta: {
        title: "等级说明",
        keepAlive: false,
        footer: true,
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Grade.vue"),
    },
    {
      path: "/PayPass",
      name: "PayPass",
      meta: {
        title: "修改支付密码",
        keepAlive: false,
        footer: true,
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/PayPass.vue"),
    },
    {
      path: "/login1",
      name: "Login1",
      meta: {
        title: "登录",
        keepAlive: false,
        footer: true,
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Login1.vue"),
    },
    ...module,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: true,
        backgroundColor: "#fff",
      },
      component: Loading,
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB",
      },
      component: NotDefined,
    },
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  },
});

const { back, replace } = router;

router.back = function () {
  this.isBack = true;
  back.call(router);
};
router.replace = function (...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  const { title, backgroundColor, footer, home, auth } = to.meta;
  console.log(to.name, form.name);
  if (auth === true && !$store.state.app.token) {
    if (form.name === "Login") return;
    return toLogin(true, to.fullPath);
  }
  document.title = title || process.env.VUE_APP_NAME || "ASM太平洋";
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //控制悬浮按钮是否显示
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});

export default router;

